<!-- Breadcrumb -->
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a routerLink="">Home</a>
    </li>
    <li class="breadcrumb-item">Minha Conta</li>
    <li class="breadcrumb-item active">
      Cartão do Cidadão
    </li>
  </ol>
<!-- //.Breadcrumb -->

<!-- Print -->
<div class="btn-print text-right">    
  <a onClick="window.print()" role="button"><i class="fa fa-print" aria-hidden="true"></i> Imprimir</a>
</div>
<!-- //.Print  -->

<h2 class="titulo-interna">Cartão do cidadão</h2>

<p class="text-justify">
  Imprima o cartão e apresente-o ao caixa dos estabelecimentos.
  Você facilita a emissão da "Nota Premiada Bahia" e aumenta suas chances para ganhar nos sorteios e demais vantagens da Campanha NPB!
</p>

<!-- Card Group -->
<div class="card-group cartao" id="printable">

  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="user-info align-middle">
            <img class="mx-auto d-block" src="assets/images/logo_NPB.png" alt="logo_NPB">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card text-center">
    <div class="card-body">

     <div class="row">
        <div class="col-12">
            <div class="user-info align-middle">
              <p class="h6">{{consumidorModel.nome}}</p>
              <p class="h5">{{consumidorModel.cpf | cpfMask}}</p>
            </div>
        </div>

        <div class="col-12">
          <p>www.notapremiadabahia.ba.gov.br</p>
        </div>

      </div>
    </div>
  </div>
</div>
<!-- //.Card Group -->




// WEBPACK FOOTER //
// ./src/app/restrito/consumidor/consumidor-cartao/consumidor-cartao.component.html